<template>
  <div
    class="ui-loader"
    :style="containerStyles"
  >
    <svg
      xmlns="http://www.w3.org/2000/svg"
      x="0px"
      y="0px"
      viewBox="0 0 60 60"
    >
      <circle
        r="24"
        cx="30"
        cy="30"
        :stroke-width="stroke"
      />
    </svg>
  </div>
</template>

<script>

export default {
  name: 'UiLoader',

  props: {
    size: {
      type: [Number, String],
      default: 24,
    },

    stroke: {
      type: [Number, String],
      default: 4,
    },
  },

  computed: {
    containerStyles() {
      return this.size === 24 ? {} : {
        width: `${this.size}px`,
        height: `${this.size}px`,
      }
    },
  },
};
</script>

<style lang="scss">
.ui-loader {
  width: 24px;
  height: 24px;

  svg {
    width: 100%;
    height: 100%;
    animation: 1.4s loader-rotate linear infinite;
  }

  circle {
    fill: none;
    stroke: currentColor;
    transform-origin: 30px 30px;
    animation: 1.4s loader-dash ease-in-out infinite;
  }

  @keyframes loader-dash {
    0% {
      stroke-dasharray: 1, 240;
      stroke-dashoffset: 0;
    }
    50% {
      stroke-dasharray: 120, 240;
      stroke-dashoffset: -15px;
    }
    to {
      stroke-dasharray: 120, 240;
      stroke-dashoffset: -150px;
    }
  }

  @keyframes loader-rotate {
    to {
      transform: rotate(1turn);
    }
  }
}
</style>
